<template>
  <div>
    <el-dropdown placement="bottom" trigger="click" @command="handleCommand">
      <span class="el-dropdown-link"> {{defValue.label}}<i class="el-icon-arrow-down el-icon--right"></i> </span>
      <el-dropdown-menu class="content" slot="dropdown">
        <el-dropdown-item :class="act==index?'act':''" v-for="(item,index) in list" :key="item.value" :command="{...item,index}">{{item.label}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
export default {
  name: 'aDropdown',
  props: {
      lists:{
          type:Array,
          default:()=> []
      },
      value:{
          type:[String,Number]
      }
  },
  data() {
    return {
        list:this.lists,
        act:undefined,
        defValue:{}
    }
  },
  created() {
      this.init()
  },
  watch:{
    lists(newValue){
      console.log(newValue);
      this.list = newValue
      this.init()
      this.$forceUpdate();
    }
  },
  methods: {
    init(){
      this.list.forEach((el,index) =>{
          if (el.value == this.value) {
              this.act = index;
              this.defValue = el
          }
      })
    },
      handleCommand(v){
          console.log(v);
          if (this.act == v.index) {
            return
          }
          this.act = v.index;
          this.defValue = v
          this.$emit('dropSelect',v)
      }
  },
}
</script>

<style lang="scss" scoped>
.el-dropdown-link {
    cursor: pointer;
    font-weight: 700;
    font-size: 16px;
  }
  .el-icon-arrow-down {
    font-size: 16px;
  }
  .content{
      max-height: 300px!important;
      overflow: auto;
  }
  ::v-deep .act{
      background-color: #66b1ff;
      color: #fff;
      &:hover{
          background-color: #66b1ff;
          color: #fff;
      }
  }
  </style>
